import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBaseDeferred } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBaseDeferred';

/**
 * Exit Intent Save Prompt experiment
 * Deferred: ExitIntentSavePrompt is always mounted - expose only when the prompt would show.
 */
export const useExitIntentSavePromptDeferredExperiment = () => {
    const { isShowingFeature: variant, expose } = useAmplitudeExperimentBaseDeferred(
        AmplitudeExperiments.ExitIntentSavePrompt,
        AmplitudeVariants.ExitIntentSavePrompt.Treatment
    );
    return { expose, variant };
};
